module.exports = __webpack_public_path__ + "img/btcd.73be065a.svg";